import { CustomerInfoStep } from '@components/Checkout/steps/CustomerInfoStep';
import { InstallationStep } from '@components/Checkout/steps/InstallationStep';
import { PhoneNumberStep } from '@components/Checkout/steps/PhoneNumberStep';
import { ProductReviewStep } from '@components/Checkout/steps/ProductReviewStep';
import type { CheckoutStep } from '@t/checkout.types';
import type { StepContentComponent, StepContentProps } from './stepDescriptors.types';

const CustomerContent = ({ isActive, isCompleted, customerStepProps }: StepContentProps) => (
  <CustomerInfoStep isActive={isActive} isCompleted={isCompleted} {...customerStepProps} />
);

const PhoneContent = ({ isActive, isCompleted, phoneStepProps }: StepContentProps) => (
  <PhoneNumberStep isActive={isActive} isCompleted={isCompleted} {...phoneStepProps} />
);

const InstallationContent = ({ isActive, isCompleted, installationStepProps }: StepContentProps) => (
  <InstallationStep isActive={isActive} isCompleted={isCompleted} {...installationStepProps} />
);

const ReviewContent = ({ isActive, reviewStepProps }: StepContentProps) => (
  <ProductReviewStep isActive={isActive} {...reviewStepProps} />
);

export const STEP_CONTENT: Record<CheckoutStep, StepContentComponent> = {
  customer: CustomerContent,
  phone: PhoneContent,
  installation: InstallationContent,
  review: ReviewContent,
};
